import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { MovimentacaoProduto } from '../../types/estoque';
import { estoqueProdutosService, movimentacoesService, armazensService } from '../../services';
import { makeOptionLoader } from '../../utils/optionLoaders';

const fields: ResourceField<MovimentacaoProduto>[] = [
  {
    name: 'estoque',
    label: 'Estoque (produto/localização)',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      estoqueProdutosService.list,
      (item: any) =>
        `${item.produto_nome ?? item.produto ?? ''} - ${item.localizacao ?? ''}`.trim(),
    ),
    required: true,
  },
  {
    name: 'tipo_movimento',
    label: 'Tipo de movimento',
    type: 'select',
    options: [{ label: 'Transferência', value: 'TRANSFERENCIA' }],
    required: true,
  },
  { name: 'quantidade', label: 'Quantidade', type: 'number', valueType: 'number', required: true },
  {
    name: 'origem',
    label: 'Origem (armazém)',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      armazensService.list,
      (item: any) => item.nome ?? `Armazem #${item.id}`,
    ),
    required: true,
  },
  {
    name: 'destino',
    label: 'Destino (armazém)',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      armazensService.list,
      (item: any) => item.nome ?? `Armazem #${item.id}`,
    ),
    required: true,
  },
  { name: 'operador', label: 'Operador', required: true },
  { name: 'observacoes', label: 'Observações', type: 'textarea' },
];

export const MovimentacoesProdutosFormPage: React.FC = () => (
  <ResourceFormPage
    title="Transferência de estoque"
    description="Registrar transferência entre armazéns."
    fields={fields}
    service={movimentacoesService}
    redirectPath="/admin/movimento/transferencias-estoque"
    cancelPath="/admin/movimento/transferencias-estoque"
    initialValues={{ tipo_movimento: 'TRANSFERENCIA' }}
  />
);
